/** İnteract kulüpleri — görsel kaynağı. Metinler i18n: `interactClubs.*`. */
export const INTERACT_CLUBS_IMAGE_SRC =
    'https://istanbulrotary.org/img/db/1_1.jpg';
